import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react'
import { AnyObject, BaseAuthentication, Encounter } from '@hb/shared'
import { EncounterView } from '../../EncounterView'

interface HistoricalAuthModalProps {
  // The version being viewed: a previous authentication, the current authenticated
  // version ('current'), or null when the modal is closed.
  viewingHistoricalAuth: BaseAuthentication<AnyObject> | 'current'
  encounter: Encounter
  examId: string
  patientId: string
  onClose: () => void
}

// Read-only view of a historical (or current) authenticated version of the encounter,
// shown in a large modal over the form.
export const HistoricalAuthModal = ({
  viewingHistoricalAuth,
  encounter,
  examId,
  patientId,
  onClose,
}: HistoricalAuthModalProps) => (
  <Modal isOpen onClose={onClose} size="xl">
    <ModalOverlay />
    <ModalContent h="80vh">
      <ModalBody p={0} h="100%">
        <EncounterView
          examId={examId}
          patientId={patientId}
          encounterOverride={{
            ...encounter,
            data:
              viewingHistoricalAuth === 'current'
                ? (encounter.authentication?.formData ?? encounter.data)
                : viewingHistoricalAuth.formData,
            draftData: undefined,
            authentication: undefined,
          }}
          onClose={onClose}
        />
      </ModalBody>
    </ModalContent>
  </Modal>
)
